import type { ElementState } from '../renderer/ElementState';

import type { IVideoCreatorStore } from '@src/stores/IVideoCreatorStore';
import type { ExtraElementData, VolumeKeyPoint } from '../types.ts/story';

export const areVolumeKeyPointsSupportedBy = (
  element: ElementState,
): boolean => {
  return element.source?.type === 'audio';
};

export const getVolumeKeyPointsOf = (
  videoCreator: IVideoCreatorStore,
  element: ElementState,
): VolumeKeyPoint[] | undefined => {
  let result = (
    videoCreator.currentVideo?.extraElementData[
      element.source?.id
    ] as ExtraElementData
  )?.volumeKeyPoints;
  if (!areVolumeKeyPointsSupportedBy(element)) {
    result = undefined;
  }
  return result;
};
